export * from './lib/+state/basket.facade';
export * from './lib/+state/basket.reducer';
export * from './lib/+state/basket.selectors';
export * from './lib/+state/devices/devices.reducer';
export * from './lib/+state/devices/devices.selectors';
export * from './lib/+state/quotes.facade';
export * from './lib/+state/quotes/quotes.effects';
export * from './lib/+state/quotes/quotes.reducer';
export * from './lib/+state/quotes/quotes.selectors';
export * from './lib/services/basket-api.service';
export * from './lib/sky-data-access-basket.module';
import * as DevicesActions from './lib/+state/devices/devices.actions';
import * as DevicesSelectors from './lib/+state/devices/devices.selectors';
import * as QuotesActions from './lib/+state/quotes/quotes.actions';
import * as QuotesSelectors from './lib/+state/quotes/quotes.selectors';

export const BasketActions = {
  ...DevicesActions,
  ...QuotesActions,
};

export const BasketSelectors = {
  ...DevicesSelectors,
  ...QuotesSelectors,
};
